/**
 * Transfer wizard business logic — composes progress, loaders, entity init, actions, and navigation.
 */
import { useRef } from 'react'
import type { TransferProcessWorkflowDeps } from './transferWorkflowTypes'
import { useTransferProcessProgress } from './useTransferProcessProgress'
import { useTransferProcessLoaders } from './useTransferProcessLoaders'
import { useTransferProcessEntityInit } from './useTransferProcessEntityInit'
import { useTransferProcessActions } from './useTransferProcessActions'
import { useTransferProcessWizardNav } from './useTransferProcessWizardNav'

export type { TransferProcessWorkflowDeps } from './transferWorkflowTypes'

export function useTransferProcessWorkflow(deps: TransferProcessWorkflowDeps) {
  const firsttimeRef = useRef(true)

  const progress = useTransferProcessProgress(deps, firsttimeRef)
  const loaders = useTransferProcessLoaders(deps, progress)
  const entity = useTransferProcessEntityInit(deps, loaders, firsttimeRef)
  const actions = useTransferProcessActions(deps, loaders, progress)
  const wizard = useTransferProcessWizardNav(deps, actions, progress)

  return {
    ...loaders,
    ...entity,
    ...progress,
    ...actions,
    ...wizard,
    firsttimeRef,
  }
}
